import { ConsortiumRepoImpl } from "domain/repository/ChargeDetailMaintenance/ConsortiumRepoImpl";
import { ParticipationRateRepoImpl } from "domain/repository/ParticipationRate/ParticipationRateRepoImpl";
import { useParticipationRateMaintenanceTracked } from "presentation/store/ParticipationRate/ParticipationRateMaintenanceProvider";
import { ParticipationRateMaintenanceVM } from "presentation/viewModel/ParticipationRate/ParticipationRateMaintenanceVM";
import { useMemo } from "react";

export const useParticipationRateMaintenanceVM = () => {
    const [, setParticipationRateMaintenanceState] = useParticipationRateMaintenanceTracked();
    const participationRateMainVM = useMemo(() =>
        ParticipationRateMaintenanceVM({
            dispatch: [setParticipationRateMaintenanceState],
            repo: ParticipationRateRepoImpl(),
            consortiumRepo: ConsortiumRepoImpl(),
        }), [setParticipationRateMaintenanceState])

    return participationRateMainVM
}

